import React, { useRef, useState } from "react";
import { Tooltip, Popover } from "@mui/material";
import { IconButton } from "@mui/material";
const MessageA1icon = (props) => {
    const [clicked, setClicked] = useState(false);
    const removeImgTag= (htmlString) => {
        return htmlString.replace(/<img[^>]*>/g, '');
      }
    const onClickHandler = (e) => {
        if (!props.disable) {
            props.handleClick(props.item.code);
            props.setTextOnClick(removeImgTag(props.item.text));
            setClicked(true);
        }
    };
    return (
        <>
            <button
                className={
                    props.isFallback ? "chat-label action-tab" : "chat-label action-tab"
                }
                id="main-tab1"
                style={{
                    color: clicked && "grey",
                    pointerEvents: clicked && "none",
                }}
                onClick={onClickHandler}
            >
                <span style={{ fontFamily: 'VoltePlay-Medium, sans-serif', display: 'flex', gap: '6px' }} dangerouslySetInnerHTML={{ __html: props?.item?.text }} />
            </button>
        </>
    );
};
export default MessageA1icon;